import { Text } from 'ui'

export const EmptyState = () => {
  return (
    <Text color={'lightText'} mb={3}>
      Your team members will appear here.
    </Text>
  )
}
